module.exports = __webpack_public_path__ + "static/media/banner.a19e424e.png";